import axios from 'axios';

export async function getOsData(): Promise<string> {
  const res = await axios.get('https://api.ipify.org/?format=json');
  return res.data.ip;
}
